export const slug = (input) => {
  if (!input) return '';

  // make lower case and trim
  var slug = input.toLowerCase().trim();

  // remove accents from charaters
  slug = slug.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  // replace invalid chars with spaces
  slug = slug.replace(/[^a-z0-9\s-]/g, ' ').trim();

  // replace multiple spaces or hyphens with a single hyphen
  slug = slug.replace(/[\s-]+/g, '-');

  return slug;
};

export const truncateForLink = (t) => {
  //('very long string'.slice(0,10))+'...'
  return t.slice(0, 30);
};

export const getValFrmDict = (k2) => {
  let o = {};
  sdgs.forEach((k) => {
    o[slug(k.name)] = k.name;
  });
  return o?.[k2];
};

export const sdgs = [
  { name: 'no poverty' },
  { name: 'Zero Hunger' },
  { name: 'Good Health and Well being' },
  { name: 'Quality Education' },
  { name: 'Gender Equality' },
  { name: 'Clean Water and Sanitation' },
  { name: 'Affordable and clean Energy' },
  { name: 'Decent Work and Economic Growth' },
  { name: 'Industry, innovation and Infrastructure' },
  { name: 'Reduced Inequalities' },
  { name: 'Sustainable cities and communities' },
  { name: 'Responsible Consumption and Production' },
  { name: 'Climate Action' },
  { name: 'Life Below Water' },
  { name: 'Life On Land' },
  { name: 'Peace, Justice and Strong Instuitions' },
  { name: 'Partnerships for the goals' },
];
